// extracted by mini-css-extract-plugin
module.exports = {"base-drop-down":"dropDown_base-drop-down__x2KNf"};